import { showChannelRequestErrorToast } from 'services/toaster';
import { isChannelRequestTimeout } from 'shared/channels/errors';

/**
 * Sends a change without waiting for it, e.g. before leaving a details view.
 * Only a rejection of the server is shown: after a timeout the change may
 * still be saved, and a later failure is reported by the collection's
 * subscription (`createEntityCollectionActions`).
 */
export function sendChangeWithoutWaiting(action: string, change: () => Promise<unknown>): void {
  change().catch((error: unknown) => {
    if (!isChannelRequestTimeout(error)) {
      showChannelRequestErrorToast(`Error while ${action}`, error);
    }
  });
}
